export default __webpack_public_path__ + "media/images/icons/icon-social-vk-8c63ebe77e08710d65d8b0b86de40c5e.svg";